import axios from 'axios';

export function getLocalizations() {
    return axios.get('/api/services/app/Localization/GetLocalizations');
}
